import {getRequest, postRequest} from "../../src/api/index.js";
import {
    ACTIVATION_ERROR,
    ACTIVATION_HEADING_TEXT
} from "../../src/actions/types.js";

export const patientActivationHeadingText = async (data, cb) => async (
    dispatch
) => {
    try {
        const res = await getRequest(`/user/activationheadingtext/` + data.encString, "user", (status) => {
            return (status >= 200 && status < 300) || status === 400; // default
        });

        if (res.status !== 400) {
            dispatch({
                type: ACTIVATION_HEADING_TEXT,
                payload: res.data
            })

            cb(res.data);
        } else {
            dispatch({
                type: ACTIVATION_ERROR,
                payload: res.data.errors[0]
            });
        }
    } catch (err) {
        if (err.response) {
            // There is an error response from the server
            // You can anticipate error.response.data here
            if (err.response.data && err.response.data.errors[0]) {
                dispatch({
                    type: ACTIVATION_ERROR,
                    payload: err.response.data.errors[0]
                });
            } else {
                const error = err.response.data;
                dispatch({
                    type: ACTIVATION_ERROR,
                    payload: err.message
                });
            }
        } else if (err.request) {
            // The request was made but no response was received
            // Error details are stored in error.reqeust
            dispatch({
                type: ACTIVATION_ERROR,
                payload: err.request
            });
        } else if (err) {
            dispatch({
                type: ACTIVATION_ERROR,
                payload: err.message
            });
        } else {
            // Some other errors
            dispatch({
                type: ACTIVATION_ERROR,
                payload: "Something went wrong."
            });
        }
    }
};
